import { GlobalLeaderboardRecordDTO } from "../../service/dto/GlobalLeaderboardDTO";
import { GameType } from "./types";

export class GameRecord {
  usedTimeMs: number;
  gameType: GameType;
  district: string | null;
  name: string | null;
  roomName: string;
  schoolName: string | null;
  state: string | null;
  rank?: string | null;

  constructor(dto: GlobalLeaderboardRecordDTO, gameType: GameType) {
    this.usedTimeMs = dto.score || 0;
    this.gameType = gameType;
    this.district = dto.district || null;
    this.name = dto.name || null;
    this.roomName = dto.roomName || "";
    this.schoolName = dto.schoolName || null;
    this.state = dto.state || null;
    this.rank = dto.rank || null;
  }
}
